import Icon from "./icons/Icon";
import { WartePunkte } from "./StatusPille";
import "./SongLoesung.css";

/**
 * Die Loesung: Cover, Titel, Interpret, Album · Jahr.
 * gross: Cover oben und gross (Loesung halten, Du bist dran, Aufgeloest),
 * sonst kompakt nebeneinander (Bewertung). Solange Spotify noch liefert
 * bzw. wenn nichts kam, ein Hinweis statt leerer Felder.
 * @category spiel
 */
export function SongLoesung({ isSongLoading = false, songData, gross = false }) {
  const klassen = `loesung${gross ? " gross" : ""}`;
  if (isSongLoading) {
    return (
      <div className={`${klassen} hinweis`}>
        <span className="loesung-hinweis">
          Song-Daten kommen <WartePunkte />
        </span>
      </div>
    );
  }
  if (!songData?.title) {
    return (
      <div className={`${klassen} hinweis`}>
        <span className="loesung-hinweis">
          <Icon name="x" size={18} />
          Keine Songdaten von Spotify
        </span>
      </div>
    );
  }
  const meta = [songData.album, songData.year].filter(Boolean).join(" · ");
  return (
    <div className={klassen}>
      {songData.cover ? (
        <img className="loesung-cover" src={songData.cover} alt="" />
      ) : (
        <span className="loesung-cover leer">
          <Icon name="album" size={gross ? 64 : 34} />
        </span>
      )}
      <div className="loesung-text">
        <span className="loesung-titel">{songData.title}</span>
        <span className="loesung-interpret">{songData.artist}</span>
        {meta && <span className="loesung-meta">{meta}</span>}
      </div>
    </div>
  );
}

export default SongLoesung;
